const TOKEN_KEY = 'token'
const USER_ID_KEY = 'user_id'
const STAFF_KEY = 'staff'
const MENUS_KEY = 'menus'
const REMEMBER_KEY = 'login_remember'
const ACCOUNT_KEY = 'login_account'
const PASSWORD_KEY = 'login_password'

export function getToken() {
    return localStorage.getItem(TOKEN_KEY) || ''
}

export function getStaff() {
    const raw = localStorage.getItem(STAFF_KEY)
    if (!raw) return null
    try {
        return JSON.parse(raw)
    } catch (error) {
        return null
    }
}

export function getMenus() {
    const raw = localStorage.getItem(MENUS_KEY)
    if (!raw) return []
    try {
        const menus = JSON.parse(raw)
        return Array.isArray(menus) ? menus : []
    } catch (error) {
        return []
    }
}

export function setAuth(payload) {
    if (!payload) return

    if (payload.token) {
        localStorage.setItem(TOKEN_KEY, payload.token)
    }
    if (payload.staff && payload.staff.id) {
        localStorage.setItem(USER_ID_KEY, String(payload.staff.id))
        localStorage.setItem(STAFF_KEY, JSON.stringify(payload.staff))
    }
    if (payload.menus) {
        localStorage.setItem(MENUS_KEY, JSON.stringify(payload.menus))
    }
}

export function setToken(token) {
    if (token) {
        localStorage.setItem(TOKEN_KEY, token)
    }
}

export function clearAuth() {
    localStorage.removeItem(TOKEN_KEY)
    localStorage.removeItem(USER_ID_KEY)
    localStorage.removeItem(STAFF_KEY)
    localStorage.removeItem(MENUS_KEY)
}

export function saveRememberAccount(account, password, remember) {
    if (remember) {
        localStorage.setItem(REMEMBER_KEY, '1')
        localStorage.setItem(ACCOUNT_KEY, account)
        localStorage.setItem(PASSWORD_KEY, password)
        return
    }

    localStorage.removeItem(REMEMBER_KEY)
    localStorage.removeItem(ACCOUNT_KEY)
    localStorage.removeItem(PASSWORD_KEY)
}

export function loadRememberAccount() {
    if (localStorage.getItem(REMEMBER_KEY) !== '1') {
        return {
            remember: false,
            account: '',
            password: '',
        }
    }

    return {
        remember: true,
        account: localStorage.getItem(ACCOUNT_KEY) || '',
        password: localStorage.getItem(PASSWORD_KEY) || '',
    }
}
